/** @jsx jsx */
import { jsx } from "theme-ui"
import { Themed } from '@theme-ui/mdx'

import styled from "styled-components"
import theme, { rem } from "@src/theme"
const Main = ({ title, small, large, ...props }) => {
  // const brokenTitle = title.match(/.{1,30}(\s|$)/g)

  if (large) return (<Banner
    sx={{
      px: rem(5),
      pr: rem(8),
      py: rem(4.5),
      display: "inline-block",
      transform: `rotate(-0.5deg)`,
    }}
    {...props}
  >
    <Themed.h2
      sx={{
        color: "white",
        fontStyle: "italic",
        margin: 0,
      }}
    >
      <span
        sx={{
          whiteSpace: "pre-wrap",
          backgroundColor: theme.colors.midBlue,
          borderLeft: `0.1em solid ${theme.colors.midBlue}`,
          borderRight: `0.2em solid ${theme.colors.midBlue}`,
          px: rem(15),
          py: rem(10)
        }}
      >
        {title}
      </span>
    </Themed.h2>
  </Banner>)

  return (
    <Banner
      sx={{
        px: rem(5),
        pr: rem(8),
        py: rem(4.5),
        display: "inline-block",
        transform: `rotate(-0.5deg)`,
      }}
      {...props}
      small={small}
    >
      {small ? (
        <Themed.h4
          sx={{
            color: "white",
            fontStyle: "italic",
            margin: 0,
          }}
        >
          {title}
        </Themed.h4>
      ) : (
        <Themed.h3
          sx={{
            color: "white",
            fontStyle: "italic",
            margin: 0,
          }}
        >
          <span
            sx={{
              whiteSpace: "pre-wrap",
              backgroundColor: theme.colors.darkPurple,
              borderLeft: `0.1em solid ${theme.colors.darkPurple}`,
              borderRight: `0.2em solid ${theme.colors.darkPurple}`,
            }}
          >
            {title}
          </span>
        </Themed.h3>
      )}
    </Banner>
  )
}

export const CenteredAbsoluteBanner = ({ title, fontSize }) => (
  <div
    sx={{
      display: "flex",
      justifyContent: "center",
      position: "absolute",
      left: 0,
      right: 0,
      margin: "0 auto",
      bottom: "13.2px",
      width: title && title.length >= 30 ? rem(650) : "auto",
      maxWidth: "90%",
    }}
  >
    <Main title={title} fontSize={fontSize} />
  </div>
)

export default Main

const Banner = styled.div`
  background-color: ${props =>
    props.small ? theme.colors.darkPurple : "transparent"};
  margin: 0 auto;
  text-align: center;
`
